import React from "react";
import {
  groupedSelectedFeatures, countSelectedFeatures, featureLabel, partitionFeatures,
} from "@/lib/carFeatures";
import { Check, FileText, Sparkles } from "lucide-react";

export function CarFeaturesDisplay({ features = [], compact = false }) {
  const groups = groupedSelectedFeatures(features);
  const total = countSelectedFeatures(features);

  if (!total) return null;

  if (compact) {
    const { keys, custom } = partitionFeatures(features);
    const labels = [...keys.map((k) => featureLabel(k)), ...custom];
    return (
      <div data-testid="car-features-compact" className="flex flex-wrap gap-1.5 mt-3">
        {labels.slice(0, 6).map((label) => (
          <span key={label} className="text-[10px] px-2 py-0.5 rounded-full bg-electric/10 text-electric border border-electric/20">
            {label}
          </span>
        ))}
        {total > 6 && (
          <span className="text-[10px] px-2 py-0.5 rounded-full bg-white/5 text-slate-400">+{total - 6}</span>
        )}
      </div>
    );
  }

  return (
    <div data-testid="car-features-display" className="mt-10">
      <div className="flex items-center gap-2 mb-5">
        <Sparkles className="w-5 h-5 text-electric" strokeWidth={1.5} />
        <h2 className="font-heading text-2xl font-light">Felszereltség és okmányok</h2>
        <span className="text-xs text-slate-500 ml-1">({total} jellemző)</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {groups.map((group) => (
          <div key={group.id} className="glass rounded-2xl p-5">
            <div className="flex items-center gap-2 mb-3">
              {group.id === "papers" ? (
                <FileText className="w-4 h-4 text-electric" strokeWidth={1.5} />
              ) : (
                <Check className="w-4 h-4 text-electric" strokeWidth={1.5} />
              )}
              <h3 className="text-sm font-medium text-slate-200">{group.label}</h3>
            </div>
            <ul className="space-y-2">
              {group.items.map((item) => (
                <li key={item.key} className="flex items-start gap-2 text-sm text-slate-300">
                  <Check className="w-3.5 h-3.5 text-emerald-400 mt-0.5 shrink-0" strokeWidth={2.5} />
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
